import { useContext, useEffect, useRef, useState } from 'react';
// @mui
import { alpha } from '@mui/material/styles';
import { Box, Divider, Typography, Stack, MenuItem, Avatar, IconButton, Popover } from '@mui/material';
// mocks_

import { useLocation, useNavigate } from 'react-router-dom';
import { AuthContext } from 'src/components/Context/Auth/auth.context';
import { ChangeProfilePicture, GetLogedInUser } from 'src/components/services/httpServices';

// ----------------------------------------------------------------------

const MENU_OPTIONS = [
  {
    label: 'Home',
    icon: 'eva:home-fill',
  },
  {
    label: 'Profile',
    icon: 'eva:person-fill',
  },
  {
    label: 'Settings',
    icon: 'eva:settings-2-fill',
  },
];

// ----------------------------------------------------------------------

export default function AccountPopover() {
  const [open, setOpen] = useState(null);
  const [USERNAME, setUSERNAME] = useState(localStorage.getItem('name'));
  const navigate = useNavigate();
  const location = useLocation();
  const attachmentRef = useRef(null);
  const [selectedFile, setSelectedFile] = useState([]);
  const [user, setUser] = useState({});
  let { authDispatch } = useContext(AuthContext);

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };
  let {
    authState: { isAuthenticated, name, userId, profilePicture },
  } = useContext(AuthContext);
  const handleClose = () => {
    setOpen(null);
  };

  useEffect(() => {
    setUSERNAME(name);
  }, [location, USERNAME]);
  const Logout = () => {
    localStorage.clear();
    localStorage.removeItem('Item');
    setOpen(null);
    navigate('/login');
  };
  const handleChangePassword = () => {
    setOpen(null);
    navigate(`/app/ChangePassword`);
  };
  const handleChangeProfile = (event) => {
    attachmentRef.current.click();
  };

  const fetchUser = async (uploaded) => {
    var responseChangeProfile = await ChangeProfilePicture(uploaded);
    var response = await GetLogedInUser();
    if (response !== null) {
      setUser(response);
    }
    if (responseChangeProfile.status == 200) {
      authDispatch({
        type: 'UPDATE_USER',
        profilePicture: response.profilePictureName,
      });
    }
  };

  const uploadFile = (event) => {
    event.preventDefault();
    const uploaded = [...selectedFile];
    for (let i = 0; i < event.target.files.length; i++) {
      let reader = new FileReader();
      let file = event.target.files[0];
      //  console.log('FileName', file); //I can see the file's info

      reader.onload = (event) => {
        //      console.log('event', event.target.result[0]);
        // console.log("asas", reader.result);
        const row = {
          attachment: reader.result,
          fileName: file.name,
        };
        uploaded.push(row);
        let response = fetchUser(uploaded);

        // setSelectedFile([row]);
        //      console.log('row', row);
        // console.log("State", selectedFile);
      };
      reader.readAsDataURL(file);

      //  console.log('asas', reader.result);
      reader.onerror = function (error) {
        console.log('Error: ', error);
      };
    }
    setSelectedFile(uploaded);
    // SaveAttachment();
  };
  // console.log('profilePicture:', profilePicture);
  return (
    <>
      <IconButton
        onClick={handleOpen}
        sx={{
          p: 0,
          ...(open && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
            },
          }),
        }}
      >
        <Avatar
          src={profilePicture != 'null' ? `/pictures/${profilePicture}` : account.photoURL}
          // alt={account.photoURL}
        />
      </IconButton>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 0,
            mt: 1.5,
            ml: 0.75,
            width: 180,
            '& .MuiMenuItem-root': {
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle2" noWrap>
            {USERNAME}
          </Typography>
          {/* <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {account.email}
          </Typography> */}
        </Box>

        <Divider sx={{ borderStyle: 'dashed' }} />

        {/* <Stack sx={{ p: 1 }}>
          {MENU_OPTIONS.map((option) => (
            <MenuItem key={option.label} onClick={handleClose}>
              {option.label}
            </MenuItem>
          ))}
        </Stack> */}
        <MenuItem sx={{ m: 1 }} onClick={handleChangeProfile}>
          <input style={{ display: 'none' }} ref={attachmentRef} type="file" onChange={uploadFile} />
          Change Profile Picture
        </MenuItem>
        <MenuItem onClick={handleChangePassword} sx={{ m: 1 }}>
          Change Password
        </MenuItem>
        {/* <Divider sx={{ borderStyle: 'dashed' }} /> */}

        {/* <MenuItem sx={{ m: 1 }}>
          <ModalLayout title="Logout" description="Are You Sure?" Hit={Logout} />
        </MenuItem> */}
      </Popover>
    </>
  );
}
